var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.perms
      ? _c(
          "section",
          { staticClass: "content-filters" },
          [
            _c("basic-form", [
              _c("div", { staticClass: "cof-row" }, [
                _c(
                  "div",
                  { staticClass: "full-w" },
                  [
                    _c("mnb-input", {
                      attrs: { label: "Message" },
                      model: {
                        value: _vm.form.message,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "message", $$v)
                        },
                        expression: "form.message"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.form.message.$dirty && _vm.$v.form.message.$invalid
                      ? _c("span", { staticClass: "error" }, [
                          _vm._v("This field is required !")
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cof-row" }, [
                _c(
                  "div",
                  { staticClass: "full-w" },
                  [
                    _c("label", [_vm._v("Message Expiry")]),
                    _vm._v(" "),
                    _c("date-time-picker", {
                      attrs: {
                        "value-type": "String",
                        "value-format": "yyyy-LL-dd",
                        format: "yyyy-LL-dd",
                        "time-picker": false,
                        "auto-close": true,
                        "min-date": _vm.minDate
                      },
                      model: {
                        value: _vm.form.expiresAt,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "expiresAt", $$v)
                        },
                        expression: "form.expiresAt"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Leave blank for no expiry date")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cof-row" }, [
                _vm.$hasPerm("add-system-message")
                  ? _c("div", { staticClass: "cof-field mobinl" }, [
                      _c("label", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "main",
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v("Add Message")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cof-field mobinl" }, [
                  _c("label", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "second",
                      on: {
                        click: function($event) {
                          return _vm.resetField()
                        }
                      }
                    },
                    [_vm._v("Reset Fields")]
                  )
                ])
              ])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("section", { staticClass: "content-tlist" }, [
      _c(
        "table",
        { staticClass: "content-table" },
        [
          _vm._m(1),
          _vm._v(" "),
          _vm._l(_vm.messages, function(item, i) {
            return _c("tr", { key: i }, [
              _c("td", [
                _c("span", [_vm._v("Date")]),
                _vm._v(
                  _vm._s(_vm._f("date")(item.createdAt, "MM/D/YYYY hh:mm A"))
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("span", [_vm._v("Message Expiry")]),
                  item.expiresAt
                    ? [
                        _vm._v(
                          _vm._s(_vm._f("date")(item.expiresAt, "MM/D/YYYY"))
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("td", [
                _c("span", [_vm._v("By")]),
                _vm._v(
                  _vm._s(item.createdBy ? item.createdBy.firstName : "") +
                    " " +
                    _vm._s(item.createdBy ? item.createdBy.lastName : "")
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { width: "500px", "padding-right": "10px" } },
                [
                  _c("span", [_vm._v("Messages")]),
                  _vm._v(" "),
                  !_vm.isEdit(i)
                    ? [_vm._v(" " + _vm._s(item.message))]
                    : _c("mnb-textarea", {
                        ref: "input_" + i,
                        refInFor: true,
                        attrs: {
                          classes: {
                            noUpdate: _vm.isEdit(i),
                            messageField: true
                          },
                          full: ""
                        },
                        on: { input: _vm.mixin_autoResize_resize },
                        model: {
                          value: _vm.editingText[i],
                          callback: function($$v) {
                            _vm.$set(_vm.editingText, i, $$v)
                          },
                          expression: "editingText[i]"
                        }
                      })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("span", [_vm._v("Options")]),
                  _vm._v(" "),
                  _vm.isEdit(i)
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "action-button save",
                            on: {
                              click: function($event) {
                                return _vm.saveUpdate(i)
                              }
                            }
                          },
                          [_vm._v("Save")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "action-button cancel",
                            on: {
                              click: function($event) {
                                return _vm.cancelEdit(i)
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      ]
                    : [
                        _vm.$hasPerm("update-system-message")
                          ? _c(
                              "button",
                              {
                                staticClass: "action-button save",
                                on: {
                                  click: function($event) {
                                    return _vm.editMessage(i)
                                  }
                                }
                              },
                              [_vm._v("Update")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$hasPerm("remove-system-message") && item.archived
                          ? _c(
                              "button",
                              {
                                staticClass: "action-button remove",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteMessage(item.id)
                                  }
                                }
                              },
                              [_vm._v("Remove")]
                            )
                          : !item.archived
                          ? _c(
                              "button",
                              {
                                staticClass: "action-button cancel",
                                on: {
                                  click: function($event) {
                                    return _vm.archivedMessage(item.id)
                                  }
                                }
                              },
                              [_vm._v("Archive")]
                            )
                          : _vm._e()
                      ]
                ],
                2
              )
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_c("h2", { staticClass: "inner-headers" })])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticStyle: { width: "15%" } }, [_vm._v("Date")]),
      _vm._v(" "),
      _c("th", { staticStyle: { width: "15%" } }, [_vm._v("Expiry")]),
      _vm._v(" "),
      _c("th", { staticStyle: { width: "15%" } }, [_vm._v("By")]),
      _vm._v(" "),
      _c("th", { staticStyle: { width: "40%" } }, [_vm._v("Message")]),
      _vm._v(" "),
      _c("th", [_vm._v("Options")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }